import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(duration);

export const timeZone = dayjs.tz.guess();

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD-HH-mm-ss';

export const getTimeZoneDate = value =>
  dayjs.utc(value, DEFAULT_DATE_FORMAT).tz(timeZone);

export function dateFormatter(value, format = DEFAULT_DATE_FORMAT) {
  const date = getTimeZoneDate(value);
  return date.format(format);
}

export function dateRangeFormatter(
  [startDate, endDate],
  format = DEFAULT_DATE_FORMAT
) {
  return [dateFormatter(startDate, format), dateFormatter(endDate, format)];
}

export function getDateLabels(
  [startDate, endDate],
  format = DEFAULT_DATE_FORMAT
) {
  return [
    dayjs(startDate, DEFAULT_DATE_FORMAT).format(format),
    dayjs(endDate, DEFAULT_DATE_FORMAT).format(format),
  ];
}

export function getDateFromFormatedString([startDate, endDate]) {
  return [
    dayjs(startDate, DEFAULT_DATE_FORMAT).toDate(),
    dayjs(endDate, DEFAULT_DATE_FORMAT).toDate(),
  ];
}
